import { ListViewColumnDefinition } from '@components/UI-Components/StandardTableView/models/ListviewColumnDefinition'
import { ZoneCounterOffer } from '@modules/common/models/interfaces/ZoneCounterOffer'
import { action, observable } from 'mobx'
interface BuyingSessionProduct {
  productId: string
  buyingSessionId: string
}

export class CollectionStore {
  @observable selectedViewAttributeSelectorTab = 'product_attributes'

  // For multiselect actions
  @observable selectedProducts: Array<BuyingSessionProduct> = []

  @observable listViewColumnDefinitionForCounterOffer: Array<ListViewColumnDefinition> =
    []

  @action buildColumnViewDefinitionForCounterOffer = (
    zoneCounterOffer?: Array<ZoneCounterOffer>
  ) => {
    if (
      (!zoneCounterOffer &&
        this.listViewColumnDefinitionForCounterOffer &&
        this.listViewColumnDefinitionForCounterOffer.length > 3) ||
      (zoneCounterOffer && zoneCounterOffer.length)
    ) {
      this.listViewColumnDefinitionForCounterOffer = []
    }
  }

  @action onViewAttributeSelectorTabChange = (events, value) => {
    Object.assign(this, { selectedViewAttributeSelectorTab: value })
  }

  @action resetSelectedProducts = () => {
    this.selectedProducts = []
  }
}
